<template>
    <section>
        <div class="page">
            <div>
                <h2>
                    Using emojis
                </h2>
                <p>
                    To use emojis, simply tap the icon to open the emoji selection menu. To switch back to your
                    keyboard, tap the icon.
                </p>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        components: {},
        data() {
            return {};
        },
        computed: {},
        methods: {}
    }
</script>
